<script>
	import subSelect from '@/components/layout/sub-select';
	import axios from 'axios';
	import store from '@/store/index.js'; //需要引入store
	import common from '@/common/common.js';

	export default {
		components: {
			subSelect
		},
		data() {
			return {
				queryParams: {
					currentPage: 1,
					pageSize: 10,
					defaultSort: {
						order: 'desc',
						prop: 'id'
					}
				},
				addOrUpdateForm: {},
				noPage: false,
				rules: {},
				dialogVisible: false,
				title: '',
				name: '',
				datas: [],
				totalNum: 0,
				totalPage:0,
				loading: true,
				baseUrl: axios.defaults.baseURL,
				myHeaders: {
					TOKEN: ''
				},
				multipleSelection: [],
				isOne: false,
				width: 160,
				showSelection: false,
				hashState: false,
				autoQuery: true,
				queryUrl: '/query',
				headers: {},
				permTypes:[],
				updateUrl:'',
				success_message:''
			};
		},
		filters: {
			formatState(state) {
				if (state == 1) {
					return '启用'
				} else if (state == 2) {
					return '停用'
				}
			}
		},
		methods: {
			initAuth(){
				let permTypes = sessionStorage.getItem('displayButtonList');
				if (permTypes && permTypes != 'undefined') {
					permTypes.split(",").forEach(item => {
						this.permTypes.push(item);
					})
					console.log('initAuth',this.permTypes)
				}
			},
			hasAuth(key){
				return this.permTypes.includes(key)
			},
			beforeUpload(file) {
			  // 支持的文件类型
			  const isImage = ['image/jpeg', 'image/png', 'image/jpg'].includes(file.type);
			  const isLt2M = file.size / 1024 / 1024 < 2;
			
			  if (!isImage) {
			    this.$message.error('上传图片只能是 JPG、PNG 格式!');
			  }
			  if (!isLt2M) {
			    this.$message.error('上传图片大小不能超过 2MB!');
			  }
			  return isImage && isLt2M;
			},
			setShowSelection(btns) {
				this.showSelection = false;
				let permTypes = sessionStorage.getItem('displayButtonList');
				if (permTypes && permTypes != 'undefined') {
					permTypes.split(",").forEach(item => {
						if (item == 'btn_state') {
							this.hashState = true
						}
						if (btns && btns.includes(item)) {
							this.showSelection = true;
						}
					})
				}
			},
			beforeQuery() {},
			handleQuery() {
				//查询
				this.queryParams.currentPage = 1;
				this.beforeQuery();
				this.getList();
			},
			beforeList(datas) {

			},
			getQueryParams(){
				return this.queryParams;
			},
			fillStateSw(datas){
				if(datas){
					datas.forEach(item => {
						if (item.state == 1) {
							item.stateSw = true
						} else {
							item.stateSw = false
						}
						this.fillStateSw(item.children)
					})
				}
			},
			getList() {
				this.loading = true;
				// 查询列表
				let that = this;
				this.$http({
						method: 'POST',
						url: this.url + this.queryUrl,
						data: this.getQueryParams()
					})
					.then(function(res) {
						if (res && res.data && res.data.data) {
							that.fillStateSw(res.data.data)
						}
						that.beforeList(res.data.data)
						that.datas = res.data.data;
						if (res.data.data != null) {
							if (res.data.data instanceof Array) {} else {
								that.isOne = true;
								that.createUpdateForm(res.data.data);
							}
						}
						if (!that.noPage) {
							that.totalNum = res.data.page.totalNum;
							that.totalPage=res.data.page.totalPage;
						}
						that.loading = false;
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			handleSelectionChange(val) {
				//表格复选框选中
				this.multipleSelection = val;
			},
			pageCurrentChange(val) {
				// 分页
				this.queryParams.currentPage = val;
				this.getList();
			},
			pageSizeChange(val) {
				//调整每页显示条数
				this.queryParams.pageSize = val;
				this.queryParams.currentPage = 1;
				this.getList();
			},
			successMessage(title, msg) {
				//成功提示
				this.$notify({
					title: title,
					message: msg,
					type: 'success'
				});
			},
			errorMessage(title, msg) {
				//失败提示
				this.$notify.error({
					title: title,
					message: msg,
					type: 'success'
				});
			},
			getAddData(){
				return null
			},
			handleAdd() {
				//添加弹窗
				//重置表单
				if (this.$refs.addOrUpdateForm != undefined) {
					this.$refs['addOrUpdateForm'].resetFields();
				}
				this.createUpdateForm(this.getAddData());
				this.beforeEdit();
				this.title = '添加' + this.name;
				this.dialogVisible = true;
			},
			handleEdit(row) {
				//编辑弹窗
				//重置表单
				if (this.$refs.addOrUpdateForm != undefined) {
					this.$refs['addOrUpdateForm'].resetFields();
				}
				this.createUpdateForm(row);
				this.beforeEdit(true);
				this.title = '编辑' + this.name;
				this.dialogVisible = true;
			},
			createUpdateForm(row) {
				if (row) {
					var newObj = Object.assign({}, row); //复制对象, 避免表单与表格数据 双向绑定
					this.addOrUpdateForm = newObj;
				} else {
					this.addOrUpdateForm = {};
				}
			},
			beforeEdit(isUpdate) {},
			beforeCopy(){},
			afterCopy(){},
			handleCopy(row) {
				this.beforeCopy();
				this.$http({
					method: 'POST',
					url: this.url + '/copy?id='+row.id,
					data: this.addOrUpdateForm
				})
				.then((res)=>{
					if (res.data.errorCode == '0000') {
						this.successMessage('系统提示', '复制成功');
						this.afterCopy(res.data.data)
						this.getList();
					}
				})
			},
			beforeUpdate() {},
			beforeValidate() {},
			afterUpdate(){},
			afterUpdateState(){},
			handleUpdate() {
				this.beforeValidate()
				//添加/保存
				this.$refs['addOrUpdateForm'].validate(valid => {
					if (valid) {
						var success = this.beforeUpdate();
						if (success == false) {
							return;
						}
						let that = this;
						let url = '/create';
						if (that.addOrUpdateForm.id) {
							url = '/update';
						}
						if(that.updateUrl){
							url = that.updateUrl;
						}else{
							url = that.url + url
						}
						this.$http({
								method: 'POST',
								url: url,
								data: that.addOrUpdateForm
							})
							.then(function(res) {
								if (res.data.errorCode == '0000') {
									if(that.success_message){
										that.successMessage('系统提示', that.success_message);
									}else{
										if (that.addOrUpdateForm.id == null) {
											that.successMessage('添加成功', '您成功添加一条数据');
										} else {
											if (that.isOne) {
												that.successMessage('系统提示', '修改成功');
											} else {
												that.successMessage('编辑成功', '您成功编辑一条数据');
											}
										}
									}
									that.afterUpdate(res.data.data)
									that.dialogVisible = false;
									that.getList();
								}
							});
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			batchUpdateStatus(status, statusStr, id) {
				if (!id && this.multipleSelection.length == 0) {
					this.$message({
						message: '请选择要' + statusStr + '的数据',
						type: 'warning'
					});
					return;
				}
				var msg;
				var ids = [];
				if (id) {
					msg = '此';
					ids.push(id);
				} else {
					msg = this.multipleSelection.length;
					this.multipleSelection.forEach(item => {
						ids.push(item.id);
					});
				}
				this.$confirm('此操作将' + statusStr + msg + '条数据, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
					.then(() => {
						var that = this;
						that.loading = true;
						this.$http({
								method: 'POST',
								url: that.url + '/update/state',
								data: {
									ids: ids,
									state: status
								}
							})
							.then(function(res) {
								that.loading = false;
								if (res.data.errorCode == '0000') {
									that.successMessage('操作成功', '您成功' + statusStr + res.data.data + '条数据');
									that.getList();
								}
							})
					}).catch(() => {});
			},
			updateStatus(status, statusStr, id) {
				//启用
				if (status != 0) {
					if (id == null) {
						if (this.multipleSelection.length == 0) {
							this.$message({
								message: '请选择要操作的数据',
								type: 'warning'
							});
							return;
						}
						if (this.multipleSelection.length > 1) {
							this.$message({
								message: '只能操作一条数据',
								type: 'warning'
							});
							return;
						}
						id = this.multipleSelection[0].id;
					}
				}
				this.$confirm('此操作将' + statusStr + '该条数据, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
					.then(() => {
						let that = this;
						this.$http({
								method: 'POST',
								url: that.url + '/update/state',
								data: {
									ids: [id],
									state: status
								}
							})
							.then(function(res) {
								if (res.data.errorCode == '0000') {
									that.successMessage('操作成功', '您成功' + statusStr + '一条数据');
									that.getList();
									that.afterUpdateState();
								}
							})
							.catch(function(error) {
								console.log(error);
							});
					})
					.catch(() => {
						that.errorMessage(statusStr + '失败', res.data.message);
					});
			},
			statusSwChange(item) {
				if (item.stateSw) {
					item.state = 1
					this.updateStatusNew(1, "启用", item.id)
				} else {
					item.state = 2
					this.updateStatusNew(2, "停用", item.id)
				}

			},
			updateStatusNew(status, statusStr, id) {
				//启用
				let that = this;
				this.$http({
						method: 'POST',
						url: that.url + '/update/state',
						data: {
							ids: [id],
							state: status
						}
					})
					.then(function(res) {
						if (res.data.errorCode == '0000') {
							that.successMessage('系统提示', statusStr + '成功')
							if (status == 0) {
								that.getList();
							}
						}
					})
			},
			handleStart() {
				//启用
				this.updateStatus(1, '启用');
			},
			handleStop() {
				//停用
				this.updateStatus(0, '停用');
			},
			handleDelete(row) {
				//删除
				this.updateStatus(-1, '删除',row.id);
			},
			batchStart() {
				//批量启动
				this.batchUpdateStatus(1, '启用');
			},
			batchStop() {
				//批量停用
				this.batchUpdateStatus(0, '停用');
			},
			batchDelete(id) {
				//删除
				this.batchUpdateStatus(-1, '删除');
			},
			sortChange(sortData) {
				if (sortData.order) {
					this.queryParams.sortProp = sortData.prop;
					if (sortData.order == 'ascending' || sortData.order == 'asc') {
						this.queryParams.sortOrder = 'asc';
					} else {
						this.queryParams.sortOrder = 'desc';
					}
				} else {
					this.queryParams.sortProp = this.queryParams.defaultSort.prop;
					this.queryParams.sortOrder = this.queryParams.defaultSort.order;
				}
				this.handleQuery();
			}
		},
		mounted: function() {},
		created: function() {},
		beforeMount: function() {
			this.initAuth();
			let token = sessionStorage.getItem('token');
			this.headers.Token = token;
			/* debugger;
			if( sessionStorage.getItem("perUrl")!=this.$route.path){
				//无权限
				common.routerPush(this, '/home')
			} */
			this.setShowSelection(['btn_del'])
			if (this.$route.query.queryParams) {
				var data = JSON.parse(this.$route.query.queryParams);
				for (let key in data) {
					this.$set(this.queryParams, key, data[key]);
				}
			}
			if (this.autoQuery) {
				this.handleQuery();
			}
		}
	};
</script>


// WEBPACK FOOTER //
// src/components/layout/base/base-search-front.vue